import * as React from "react";

import { Link, useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Textarea from "../../Components/Textarea";
import Button from "../../Components/Button";
import Paper from "../../Components/Paper";
import Dropzone from "../../Components/Dropzone";
import ClaimTypeSelect from "./ClaimTypeSelect";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./AddClaim.scss";

const initialFormState = {
  reclamation_type_id: "",
  file_reclamation: [],
  message: "",
};

const AddClaim = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/reclamations`, {
        reclamation_type_id: valRegister.reclamation_type_id,
        file_reclamation: valRegister.file_reclamation,
        message: valRegister.message,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/list-claim");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <>
      <div className="back-home">
        <Link to="/list-claim" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Ajouter réclamation</h1>
      <p>Veuillez remplir les champs ci dessous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <ClaimTypeSelect
            label="Type de réclamation"
            id="reclamation_type_id"
            value={valRegister.reclamation_type_id || ""}
            onChange={(e) =>
              handleChangeField(e.target.value, "reclamation_type_id")
            }
            hasError={formErrorMessages.reclamation_type_id}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.reclamation_type_id}
              </div>
            }
          ></ClaimTypeSelect>
          <Dropzone
            label="Pièce jointe"
            name="file_reclamation"
            hasError={formErrorMessages.file_reclamation}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.file_reclamation}
              </div>
            }
            value={valRegister.file_reclamation || []}
            onChange={(files) => handleChangeField(files, "file_reclamation")}
            accept="image/*,.pdf"
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />

          <Textarea
            required
            autoComplete="off"
            label="Message"
            name="message"
            type="text"
            placeholder="Veuillez insérer votre message"
            size="large"
            value={valRegister.message}
            onChange={(e) => handleChangeField(e.target.value, "message")}
            hasError={formErrorMessages.message}
            errorMessage={
              formErrorMessages.message && (
                <div className="text-danger">{formErrorMessages.message}</div>
              )
            }
          />

          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default AddClaim;
